<template>
  <v-main>
    <v-sheet :height="this.$root.windowHeight">
      <v-container class="fill-height">
        <v-col align="center">
          <v-row justify="center" align="center">
            <LoginForm/>
          </v-row>
        </v-col>
      </v-container>
    </v-sheet>
  </v-main>
</template>

<script>
import LoginForm from "@/components/LoginForm";
export default {
  name: "Login",
  components: {LoginForm},
}
</script>

<style scoped>

</style>